import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const ABOUT_IMG = 'https://images.unsplash.com/photo-1708201267130-46d12abe74cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxzdGFpbmxlc3MlMjBzdGVlbCUyMHdlbGRpbmd8ZW58MHx8fHwxNzc1NTAyNzM3fDA&ixlib=rb-4.1.0&q=85';

export default function AboutSection() {
  const { t } = useLanguage();

  const stats = [
    { num: t('about.stat1_num'), label: t('about.stat1_label') },
    { num: t('about.stat2_num'), label: t('about.stat2_label') },
    { num: t('about.stat3_num'), label: t('about.stat3_label') },
  ];

  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative" data-testid="about-image-container">
            <div className="border border-[#C8C9C7]">
              <img
                src={ABOUT_IMG}
                alt="Precision welding"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Accent line */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-[#003865]" />
          </div>

          {/* Content */}
          <div data-testid="about-content">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-[#003865]" />
              <span
                className="text-xs font-bold uppercase tracking-[0.2em] text-[#003865]"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {t('about.overline')}
              </span>
            </div>

            <h2
              data-testid="about-title"
              className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#333F48] mb-8"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t('about.title')}
            </h2>

            <div className="space-y-5" style={{ fontFamily: 'Roboto, sans-serif' }}>
              <p className="text-base leading-relaxed text-[#333F48]/80">{t('about.p1')}</p>
              <p className="text-base leading-relaxed text-[#333F48]/80">{t('about.p2')}</p>
              <p className="text-base leading-relaxed text-[#333F48]/80">{t('about.p3')}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-[#C8C9C7]">
              {stats.map((stat, i) => (
                <div key={i} data-testid={`about-stat-${i}`}>
                  <div
                    className="text-3xl lg:text-4xl font-bold text-[#003865] mb-1"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {stat.num}
                  </div>
                  <div
                    className="text-xs uppercase tracking-wider text-[#333F48]/60"
                    style={{ fontFamily: 'Roboto, sans-serif' }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
